var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"m-setting-clause m-scroll"},[_c('m-header',{attrs:{"title":"Clause"}}),_c('div',{staticClass:"main"},_vm._l((_vm.imgs),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":"img"}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }